<!-- @format -->
<template>
  <v-card
    @click.prevent="doSomething1()"
    @contextmenu.prevent="goToChangeDot()"
    :style="{
      background: $vuetify.theme.themes[theme].background,
    }"
    width="330"
    min-height="60"
    elevation="0"
    style="border-radius: 20px"
    class="ma-0 pa-0"
    outlined
  >
    <!-- <div style="position: absolute; top: 17%; right: 16%">
      <div>
        <p style="font-size: 9px">{{ created }}</p>
        <p class="mt-n5" style="font-size: 8px; text-align: right">0/4</p>
      </div>
    </div> -->
    <div style="display: flex">
      <v-banner
        :dark="lightTheme"
        :light="darkTheme"
        width="4"
        class="ma-0 pa-0 ml-3 mt-4 mb-4"
        min-height="30"
        id="a"
        :style="cssVars"
      ></v-banner>
      <!-- :style="cssVars" -->
      <div class="mt-1 ma-0 pa-0">
        <div
          class="ma-0 pa-0 mt-2 ml-3"
          style="
            width: 250px;
            font-size: 10px;
            display: flex;
            justify-content: space-between;
          "
        >
          <p>created by {{ owner }}</p>
          <p><v-icon size="10">mdi-calendar</v-icon>{{ created }}</p>
          <p><v-icon size="10">mdi-format-list-bulleted</v-icon>0/4</p>
        </div>

        <div class="ma-0 pa-0 ml-3 mt-n3">
          <v-list-item one-line class="ma-0 pa-0">
            <v-list-item-content class="ma-0 pa-0">
              <p
                style="
                  font-size: 16px !important;
                  font-weight: 600;
                  opacity: 0.8;
                "
              >
                {{ title }}
              </p>

              <p
                style="font-size: 14px !important; font-weight: 500"
                class="mt-1"
                v-if="subtitle"
              >
                {{ subtitle }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>

      <v-spacer> </v-spacer>
      <div class="mr-4">
        <div class="ma-0 pa-0">
          <v-menu
            rounded="xl"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-x
            max-width="180"
          >
            <template v-slot:activator="{ on }">
              <div style="cursor: pointer" v-on="on" class="mt-3 ml-2">
                <v-avatar
                  size="20"
                  color="grey"
                  v-if="assignedTo"
                  @click="getUsersFromTeam()"
                >
                  <v-img
                    v-if="assignedProfileImage"
                    :src="assignedProfileImage"
                  >
                  </v-img>

                  <span class="white--text" v-if="!assignedProfileImage">{{
                    assignedProfileName
                  }}</span>
                </v-avatar>

                <v-icon
                  size="25"
                  v-if="assignedTo === null"
                  @click="getUsersFromTeam()"
                  >mdi-account-circle-outline</v-icon
                >
              </div>
            </template>

            <v-card
              elevation="0"
              width="180"
              rounded="xl"
              height="210"
              style="overflow-y: hidden"
              class="ma-0 pa-0 pr-1"
            >
              <v-text-field
                v-model="searchUser"
                class="pl-2 pr-2 pt-3 mx-2"
                outlined
                rounded
                dense
                append-icon="search"
                label="Find Users"
              >
              </v-text-field>
              <v-card
                elevation="0"
                width="160"
                rounded="lg"
                height="145"
                style="overflow-x: hidden"
                class="mt-n5 ml-2 mb-2 expand"
              >
                <div
                  class="ml-2 mb-n2"
                  style="display: flex; justify-content: start"
                  v-for="(item, index) in computedUsersInformation"
                  :key="index"
                >
                  <p
                    @click="assignTaskToUser(item.username)"
                    style="cursor: pointer"
                  >
                    <v-avatar size="20" color="grey">
                      <v-img
                        v-if="item.profile.profile_image"
                        :src="item.profile.profile_image"
                      >
                      </v-img>

                      <span
                        class="white--text"
                        v-if="!item.profile.profile_image"
                        >{{ item.username[0] + "" + item.username[1] }}</span
                      >
                    </v-avatar>

                    {{ item.username }}
                  </p>
                </div>
              </v-card>
            </v-card>
          </v-menu>
        </div>

        <div style="text-align: right">
          <v-menu
            rounded="xl"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" class="pl-1" v-if="assignedTo === null">
                <v-icon size="20" :style="{ color: selectColor }"
                  >mdi-moon-full
                </v-icon>
              </v-btn>
              <v-btn icon v-on="on" v-if="assignedTo">
                <v-icon size="20" :style="{ color: selectColor }"
                  >mdi-moon-full
                </v-icon>
              </v-btn>
            </template>
            <v-color-picker
              @input="changeAnnotationColor()"
              hide-canvas
              show-swatches
              v-model="selectColor"
            ></v-color-picker>
          </v-menu>
          <!-- <v-btn icon @click.stop="changeAnnotationColor()">
            <v-avatar size="18" id="b" :style="cssVars"></v-avatar>
          </v-btn> -->
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  name: "changecard",
  components: {},
  //data
  data: function () {
    return {
      darkTheme: false,
      lightTheme: false,

      type: "hex",
      hex: "#FF0000",

      mounted: false,

      usersInformation: [],
      searchUser: "",

      assignedProfile: [],
    };
  },

  //props
  props: {
    color: String,
    idComp: { type: Number, default: 0 },
    owner: { type: String, default: "" },
    assignedTo: { type: String, default: "" },
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    created: { type: String, default: "" },
    doSomething1: { type: Function },
    goToChangeDot: { type: Function },
  },
  //computed
  computed: {
    ...mapState(["augmentableTheme"]),
    cssVars() {
      return {
        /* variables you want to pass to css */
        // "--color": this.color,
        "--color": this.selectColor,
      };
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    selectColor: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },

    computedUsersInformation() {
      const search = this.searchUser.toLowerCase();

      if (!search) return this.usersInformation;

      return this.usersInformation.filter((item) => {
        const text = item.username.toLowerCase();
        return text.indexOf(search) > -1;
      });
    },
    assignedProfileImage() {
      if (this.assignedProfile.length > 0) {
        return this.assignedProfile[0].profile.profile_image;
      } else {
        return null;
      }
    },
    assignedProfileName() {
      if (this.assignedProfile.length > 0) {
        return (
          this.assignedProfile[0].username[0] +
          "" +
          this.assignedProfile[0].username[1]
        );
      } else {
        return null;
      }
    },
  },

  //watch
  watch: {
    augmentableTheme: function (val) {
      if (val === true) {
        this.lightTheme = false;
        this.darkTheme = true;
      } else {
        this.lightTheme = true;
        this.darkTheme = false;
      }
    },

    // selectColor: function (val) {
    //   if (this.mounted === true) {
    //     //this.color = this.selectColor;
    //     let formData = new FormData();
    //     formData.append("color", val);
    //     axios
    //       .put(
    //         this.$abServerPath +"/api/glbfiles/glbputtask/" +
    //           this.idComp +
    //           "/",
    //         formData,
    //         {
    //           headers: {
    //             "Content-Type": "multipart/form-data",
    //           },
    //         }
    //       )
    //       .then((response) => {
    //         console.log(response);
    //         console.log("shamsail");
    //         // let a = "a";
    //         //this.$parent.updatedTasksData();
    //         if (typeof this.$parent.updatedTasksData === "function") {
    //           this.$parent.updatedTasksData();
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error.data);
    //       });
    //   }
    // },
  },

  mounted() {
    this.selectColor = this.color;

    if (this.augmentableTheme === true) {
      this.darkTheme = true;
    } else {
      this.lightTheme = true;
    }

    this.mounted = true;

    if (this.assignedTo) {
      this.assignedToProfile(this.assignedTo);
    }
  },
  //methods
  methods: {
    changeAnnotationColor() {
      let formData = new FormData();
      formData.append("color", this.selectColor);
      axios
        .put(
          this.$abServerPath + "/api/glbfiles/glbputtask/" + this.idComp + "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (typeof this.$parent.updatedTasksData === "function") {
            this.$parent.updatedTasksData();
          }
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    getUsersFromTeam() {
      this.usersInformation = [];

      axios
        .get(this.$abServerPath + "/api/glbfiles/glbgetusersfromgroup/", {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          var useritems = {};
          var userprofileitems = {};
          var i;
          var len;
          for (i = 0, len = response.data.length; i < len; i++) {
            //added for profile image
            if (response.data[i].profile[0].fields.profile_image) {
              response.data[i].profile[0].fields.profile_image =
                this.$abServerPath +
                "" +
                response.data[i].profile[0].fields.profile_image;
            }

            //added for profile image
            useritems = Object.assign(useritems, response.data[i].fields);
            userprofileitems = Object.assign(
              userprofileitems,
              response.data[i].profile[0].fields
            );
            useritems.profile = userprofileitems;
            this.usersInformation.push(useritems);

            useritems = {};
            userprofileitems = {};
          }
          console.log(this.usersInformation);

          // item.name = response.data;
          // this.itemsaccount.push(item);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    assignTaskToUser(username) {
      let formData = new FormData();
      formData.append("assignedTo", username);
      axios
        .put(
          this.$abServerPath + "/api/glbfiles/glbputtask/" + this.idComp + "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (typeof this.$parent.updatedTasksData === "function") {
            this.$parent.updatedTasksData();
          }
          // this.updateServerItems();
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    assignedToProfile(username) {
      this.assignedProfile = [];
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetuserinformationandprofile/" +
            username +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          var useritems = {};
          var userprofileitems = {};
          var i;
          var len;
          for (i = 0, len = response.data.length; i < len; i++) {
            //added for profile image
            if (response.data[i].profile[0].fields.profile_image) {
              response.data[i].profile[0].fields.profile_image =
                this.$abServerPath +
                "" +
                response.data[i].profile[0].fields.profile_image;
            }

            //added for profile image
            useritems = Object.assign(useritems, response.data[i].fields);
            userprofileitems = Object.assign(
              userprofileitems,
              response.data[i].profile[0].fields
            );
            useritems.profile = userprofileitems;
            this.assignedProfile.push(useritems);

            useritems = {};
            userprofileitems = {};
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");
* {
  font-family: "Nunito Sans" !important;
}
#a {
  background-color: var(--color);
}
#b {
  background-color: var(--color);
}
</style>
